import { useState, useEffect } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import $, { data } from "jquery";
// import DataTable from "datatables.net";
import { MainArea, MainAreaHeader, MainAreaBody } from "../../layout/MainArea";
import { getDataTableDom, requestToServer } from "../../utils/appUtils";
// import TableDT from "../../UI/TableDT";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { GetTrackNMEA } from "../../../api";
import { Button } from 'primereact/button';

const ROUTE_URL = "/get_conn_knap";

function NapData(props) {
    clearInterval(window.timer)
    const [serverData, setServerData] = useState(null);
    const { showErrorPage, messageBox } = useOutletContext();
    const token = localStorage.getItem('token')
    const [arrTable, setArrTable] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [date, setDate] = useState();
    const navigate = useNavigate();

    const handleAddRow = () => {
        navigate("./create");
    };


    useEffect(() => {
        let offset = (currentPage - 1) * 10;
        GetTrackNMEA(token, offset, 10).then((e) => {
            setArrTable(e.data.data)
        })
        if (!date) {
            setDate(Date.now())
        }
    }, [currentPage])
  
    const handleClick = (event) => {
        if (loading) return;
       event && event.preventDefault();
       event && event.target.blur();
        //    refreshData();
        let offset = (currentPage - 1) * 10;

        GetTrackNMEA(token, offset, 10).then((e) => {
            setArrTable(e.data.data)
        })
        setLoading(true);
        setDate(Date.now())
        setTimeout(() => {
          setLoading(false);
        }, 650);
    }

    useEffect(() => {
        requestToServer(ROUTE_URL + "?crud", { method: 'GET' }, setServerData, showErrorPage, true);
    }, []);

    if (serverData === null)
        return <MainArea loading />;

    return (
        <MainArea>
            <MainAreaHeader caption="КНАП (таблица)" />
            <MainAreaBody containerClass="">
            <div className="container-fluid px-3 py-1 dashboard">
                    <div className="row g-3">  
                        <div className="cont-table">
                            <DataTable removableSort emptyMessage="Нет данных" value={arrTable} tableStyle={{ minWidth: '50rem' }}>
                                {/* <Column field="code" sortable header="Временная метка"></Column> */}
                                <Column field="date" sortable header="Дата"></Column>
                                <Column field="time" sortable header="Время"></Column>
                                <Column field="status" sortable header={`Флаг достоверности`}></Column>
                                <Column field="latitude" sortable header={`Широта`}></Column>
                                <Column field="longitude" sortable header="Долгота"></Column>
                                <Column field="speed_kmh" sortable header={`Скорость`}></Column>
                                <Column field="course" sortable header={`Направление`}></Column>
                            </DataTable>
                            <div className="paginator">
                                <button
                                disabled={currentPage <= 1}
                                className="btn"
                                onClick={() => {
                                    setCurrentPage(currentPage - 1);
                                }}
                                >
                                {"<"}
                                </button>
                                <div className="text">{currentPage}</div>
                                <button
                                disabled={arrTable?.length < 10}
                                className="btn"
                                onClick={() => {
                                    setCurrentPage(currentPage + 1);
                                }}
                                >
                                {">"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div> 
    
                <div className="lower-line">
                    <div className="text-cont">
                        <div className="text">Состояние актуально на:</div>
                        <div className="text">{date ? new Date(date).toLocaleString() : ""}</div>
                    </div>
                    <Button className="btn-reload" loading={loading} label="Обновить сейчас" rounded onClick={handleClick}/>
              </div>
            </MainAreaBody>
        </MainArea>
    );
}

export default NapData;
